export default "__VITE_ASSET__DXsqnGaH__"